import "./App.css";
import "react-phone-number-input/style.css";
import "./shared/components/dashboard-layout/design-system/design-system.scss";
import AppRoutes from "./routing/app-routes";
import TopLevelProviders from "./shared/top-level-providers/top-level-providers";
import "./shared/components/dashboard-layout/dashboard-layout.scss";

function App() {
  return (
    <div className="App">
      <TopLevelProviders>
        <AppRoutes />
      </TopLevelProviders>
    </div>
  );
}

export default App;
